import React, { useContext } from 'react';
import { Box, Alert } from '@mui/material';
import MultipleChoiceComponent from './MultipleChoice';
import ShortAnswerComponent from './ShortAnswer';
import ProofComponent from './Proof';
import CodeComponent from './Code';
import CodeTracingComponent from './CodeTracing';
import { AuthContext } from '../../contexts/AuthContext';

function ExerciseContent({ example, onAnswerSubmitted, embedded = false, useChatPanelForAnswer = false }) {
  const { user } = useContext(AuthContext);
  const isTeacher = user?.role === 'teacher';
  
  if (!example) return null;

  const renderExercise = () => {
    switch (example.questionType) {
      case 'multiple_choice':
        return <MultipleChoiceComponent example={example} onAnswerSubmitted={onAnswerSubmitted} isTeacher={isTeacher} embedded={embedded} />;
      case 'short_answer':
        return <ShortAnswerComponent example={example} onAnswerSubmitted={onAnswerSubmitted} isTeacher={isTeacher} embedded={embedded} />;
      case 'proof':
        return <ProofComponent example={example} onAnswerSubmitted={onAnswerSubmitted} isTeacher={isTeacher} embedded={embedded} />;
      case 'code':
        return <CodeComponent example={example} embedded={embedded} />;
      case 'code_tracing':
        return <CodeTracingComponent example={example} onAnswerSubmitted={onAnswerSubmitted} isTeacher={isTeacher} embedded={embedded} useChatPanelForAnswer={useChatPanelForAnswer} />;
      default:
        return <Alert severity="error">未知题目类型: {example.questionType}</Alert>;
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '100%',
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        py: 2,
        ...(embedded ? { px: 0 } : { px: { xs: 2, sm: 3, md: 4 } }),
        boxSizing: 'border-box',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          overflowX: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          '&::-webkit-scrollbar': { width: 8 },
          '&::-webkit-scrollbar-thumb': { bgcolor: 'action.disabled', borderRadius: 4 },
          '&::-webkit-scrollbar-thumb:hover': { bgcolor: 'action.disabledBackground' },
        }}
      >
        {renderExercise()}
      </Box>
    </Box>
  );
}

export default ExerciseContent;

